import { Button } from "@ameelio/ui";
import { alpha, Box, Grid, Stack } from "@mui/material";
import { ltrTheme } from "../../theme";

type Props = {
  onDigitPress: (digit: string) => void;
  disabled?: boolean;
};

const KEYPAD_BUTTONS = [
  ["1", "2", "3"],
  ["4", "5", "6"],
  ["7", "8", "9"],
  ["*", "0", "#"],
];

export default function KeyboardContainer({
  onDigitPress,
  disabled = false,
}: Props) {
  return (
    <Box
      sx={{
        background: ltrTheme.palette.common.black,
        borderRadius: 2,
        bottom: ltrTheme.spacing(14),
        left: "50%",
        p: 2,
        position: "absolute",
        transform: "translate(-50%)",
      }}
    >
      <Stack spacing={1.5}>
        {KEYPAD_BUTTONS.map((row) => (
          <Grid container spacing={1.5} key={row.join("")}>
            {row.map((digit) => (
              <Grid size={{ xs: 4 }} key={digit}>
                <Button
                  variant="contained"
                  fullWidth
                  disabled={disabled}
                  onClick={() => onDigitPress(digit)}
                  sx={{
                    padding: 2,
                    fontSize: "1.5rem",
                    background: (th) => alpha(th.palette.common.white, 0.1),
                    color: ltrTheme.palette.common.white,
                    "&:hover": {
                      background: (th) => alpha(th.palette.common.white, 0.2),
                    },
                    "&:active": {
                      background: (th) => alpha(th.palette.common.white, 0.3),
                      transform: "scale(0.95)",
                    },
                    "&.Mui-disabled": {
                      background: (th) => alpha(th.palette.common.white, 0.05),
                      color: alpha("#fff", 0.3),
                    },
                    transition: "all 0.15s ease",
                  }}
                >
                  {digit}
                </Button>
              </Grid>
            ))}
          </Grid>
        ))}
      </Stack>
    </Box>
  );
}
